/* eslint-disable @typescript-eslint/no-explicit-any */
import { HighlightOffOutlined } from '@mui/icons-material';
import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  Grid,
  TextField,
} from '@mui/material';
import { Container } from '@mui/system';
import { useState } from 'react';
import { useOnboardMachineMutation } from 'src/backend';
import DataField from 'src/components/DataField/DataField';
import LoadingButton from 'src/components/LoadingButton';

export type OnboardMachineRequest = {
  serialNumber: string;
  machineType: string;
  machineGroupId: string;
};

type Params = {
  isOpen: boolean;
  machineType: string;
  machineGroupId: string;
  closeForm: (refetchRequired: boolean) => void;
};

function OnboardMachineForm({
  isOpen,
  machineType,
  machineGroupId,
  closeForm,
}: Params) {
  const [submitDisabled, setSubmitDisabled] = useState(true);

  const [serialNumber, setSerialNumber] = useState('');

  const [onboardMachine, { isLoading }] = useOnboardMachineMutation();

  const handleSerialChange = (value: string) => {
    if (!value || value.length === 0) {
      setSubmitDisabled(true);
      return;
    }
    setSerialNumber(value.toUpperCase());
    setSubmitDisabled(false);
  };

  const handleSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    const onboardMachineRequest: OnboardMachineRequest = {
      serialNumber,
      machineGroupId,
      machineType,
    };
    onboardMachine({ onboardMachineRequest })
      .unwrap()
      .then(() => closeForm(true))
      .catch(() => closeForm(false))
      .finally(() => {
        setSerialNumber('');
        setSubmitDisabled(true);
      });
  };
  const ALPHA_NUMERIC_DASH_REGEX = /^[a-zA-Z0-9-]+$/;

  return (
    <Dialog
      open={isOpen}
      onClose={() => closeForm(false)}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle>
        Onboard machine
        <IconButton onClick={() => closeForm(false)} style={{ float: 'right' }}>
          <HighlightOffOutlined />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit}>
          <Grid item columnSpacing={2}>
            <Grid item xs="auto" rowGap={1}>
              <DataField
                label="Serial number *"
                labelPadding="10px 0 0 0"
                value={
                  <TextField
                    variant="outlined"
                    defaultValue=""
                    placeholder="Serial number"
                    name="serialNumber"
                    inputProps={{
                      style: { textTransform: 'uppercase', width: '255px' },
                    }}
                    required
                    onKeyDown={(e) => {
                      if (!ALPHA_NUMERIC_DASH_REGEX.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => handleSerialChange(e.target.value)}
                    helperText="Alphanumeric characters and dashes only"
                  />
                }
              />
              <DataField
                label="Machine type"
                labelPadding="10px 0 0 0"
                value={
                  <TextField
                    variant="outlined"
                    defaultValue={machineType}
                    style={{ width: '280px' }}
                    disabled
                    name="machineType"
                    helperText="Read only"
                  />
                }
              />
              <Container style={{ marginTop: '5em', alignItems: 'end' }}>
                <LoadingButton
                  loading={isLoading}
                  variant="outlined"
                  type="submit"
                  disabled={submitDisabled}
                >
                  Submit
                </LoadingButton>
              </Container>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default OnboardMachineForm;
